const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'portuguese',
    locale: 'pt',
    name: 'Português',
    icon: 'pt',
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Español',
    icon: 'es',
  },
];
export default languageData;
